import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PropertyMicrosite from "./components/PropertyMicrosite";
import { AuthProvider } from "./context/AuthContext";
import { AdminLogin, AdminDashboard, ProtectedRoute } from "./components/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PropertyMicrosite />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
